// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-9f5d7e66] {\n  font-size: 32px;\n  padding: 0;\n}\n\n/* .topScroll{\n  position: relative;\n  top: 100px;\n}\n.topScrollAction{\n  position: absolute;\n  top: 50px;\n}  */\n", ""]);
// Exports
module.exports = exports;
